import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IAcceptOfficeConsentContentParameters } from '../types/OfficeConsentContent.parameters';

export const acceptOfficeConsentContent = async (
  params: IAcceptOfficeConsentContentParameters,
): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.post(
    `/credential-service/office/consents/${params.code}/accept-all`,
    {},
    {
      headers: {
        ...headers,
        'x-office': params.officeId,
      },
    },
  );
};
